<template>
  <div
    class="flex justify-start gap-3 items-start bg-pitch-black mb-4 shadow-md pb-6 pt-1 px-5 border-b-2 border-total-white-300 relative"
  >
    <div v-if="isImage" class="max-w-[30vw] object-cover">
      <template
        v-if="
          type == 'image/heic' ||
          type == 'image/heif' ||
          type == 'application/octet-stream'
        "
      >
        <video :src="fileUrl" alt="file video" class="rounded-md w-full max-w-xs"></video>
      </template>
      <template v-else>
        <img :src="fileUrl" alt="file image" class="rounded-md" />
      </template>
    </div>
    <!-- File Information -->
    <div class="flex items-start text-left flex-col">
      <h3 class="text-white font-medium text-md truncate">
        <span v-if="type.startsWith('audio')">
          <i class="fa-solid fa-music mr-2"></i>
        </span>
        <span v-else-if="!isImage"> <i class="fa-solid fa-file-alt mr-2"></i> </span>
        {{ filename.length > 20 ? filename.substring(0, 20) + "..." : filename }}
      </h3>
      <p class="pt-2">
        <span class="text-gray-400 text-xs">
          {{ formatFileSize(size) }}
        </span>
        <span class="ml-2 text-gray-400 text-xs">
          {{ type }}
        </span>
      </p>

      <p class="text-gray-400 text-xs mt-2">{{ uploader }} on {{ formattedDate }}</p>
      <div v-if="threadId" class="flex items-center gap-6 pt-3">
        <button @click="goToMessage" class="flex gap-2 text-prime-golden">
          <p class="text-xs underline">go to message</p>
        </button>
      </div>
      <div v-else class="h-5"></div>
    </div>

    <div class="h-full items-start justify-start absolute top-1 right-5">
      <button @click="downloadFile" class="text-prime-golden">
        <img src="../assets/images/download.svg" alt="download" />
      </button>
    </div>

    <div class="absolute bottom-4 right-5">
      <button @click="deleteFile" class="text-prime-golden">
        <img src="../assets/images/trash-icon.svg" alt="delete" />
      </button>
    </div>
  </div>
</template>

<script>
import { formatFileSize } from "@/misc/util";

export default {
  name: "FileCard",
  props: {
    fileId: {
      type: Number,
      required: true,
    },
    threadId: {
      type: Number,
      required: true,
    },
    filename: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    uploader: {
      type: String,
      required: true,
    },
    timestamp: {
      type: String,
      required: true,
    },
    fileUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      // Assuming timestamp is ISO format; adjust as needed
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
      };
      return new Date(this.timestamp).toLocaleDateString(undefined, options);
    },
    isImage() {
      return this.type.startsWith("image/") || this.type == "application/octet-stream";
    },
  },
  methods: {
    downloadFile() {
      window.open(this.fileUrl, "_blank");
    },
    deleteFile() {
      this.$emit("deleteFile", this.fileId);
    },
    goToMessage() {
      this.$emit("goToMessage", this.threadId);
    },
    formatFileSize(size) {
      return formatFileSize(size);
    },
  },
};
</script>
